import { useQuery } from '@apollo/client';
import { useIntl } from 'react-intl';
import styled from 'styled-components';

import { ProductType } from '@xing-com/crate-common-graphql-types';
import { GetCampaignDocument } from '@xing-com/crate-upsell-graphql';
import { Marker } from '@xing-com/marker';
import { spaceS } from '@xing-com/tokens';

const StyledMarker = styled(Marker)`
  position: absolute;
  bottom: -12px;
  right: -10%;
  padding: 0px ${spaceS};
`;

export const DiscountBadge: React.FC<{
  product: ProductType.Projobs | ProductType.Premium;
}> = ({ product }) => {
  const { formatMessage, locale } = useIntl();
  const {
    loading: loadingCampaign,
    error: campaignError,
    data,
  } = useQuery(GetCampaignDocument, {
    variables: { product, language: locale },
  });

  const discount = data?.results?.contracts.reduce((maxDiscount, contract) => {
    const { price, initialDuration } = contract;
    const cDiscount = Math.round(
      100 * (1 - price.initial / initialDuration / price.renewal)
    );
    return cDiscount > maxDiscount ? cDiscount : maxDiscount;
  }, 0);

  return !loadingCampaign && !campaignError && discount ? (
    <StyledMarker variant="strong" data-testid="current-upsell-discount">
      {formatMessage(
        {
          id: 'FRAME_HEADER_UPSELL_DISCOUNT',
        },
        { percentage: discount }
      )}
    </StyledMarker>
  ) : null;
};
